export default __webpack_public_path__ + "static/media/footerPerson.fa5062e2.svg";